module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/business/business-category/business-category-edit/business-category-edit.component.css
// module id = ./src/app/components/business/business-category/business-category-edit/business-category-edit.component.css
// module chunks = main